import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ShippingService } from '../../services/api-services/shipping.service';

@Component({
  selector: 'app-req-cancel-order',
  templateUrl: './req-cancel-order.component.html',
  styleUrl: './req-cancel-order.component.scss'
})
export class ReqCancelOrderComponent implements OnInit {
  isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ReqCancelOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shippingService: ShippingService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancelReqOrder() {
    const payload = {
      'order_id': this.data?.item?.order_id,
      'status_id': this.data?.item?.status_id
    }
    this.isLoading = true;
    this.shippingService.refill_cancel_request_order(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          this.toastr.success('Order cancelled successfully');
          this.dialogRef.close(res?.body?.success);
          this.isLoading = false;
        }
      }, error: (err) => {
        console.error('error::', err);
        this.toastr.error(err?.message || 'Failed to cancel order');
        this.isLoading = false;
      }
    });
  }

}
